import React, { useState } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import toast from 'react-hot-toast';
import { classNames, Constants, sanitizeToNumbers } from '../../utils';
import { BackIcon, LockIcon } from '../../assets/icons';
import { AuthService, GeneralService } from '../../services';
import { PasswordActive, PasswordInactive } from '../../assets/icons';

const TABS = {
	OWNER: 1,
	BENEFICIARIES: 2,
	VERIFY: 3,
};

class Register extends React.Component {

	state = {
		tab: TABS.OWNER,
		form: {
			name: '',
			last_name: '',
			gender_id: '',
			dniType: '',
			dni: '',
			phoneCode: '',
			phone: '',
			birthdate: '',
			email: '',
			address: '',
			state_id: '',
			township_id: '',
			parish_id: '',
			password: '',
			password_confirmation: '',
			google: 0,
			google_id: null,
			registered_from: Constants.REGISTERED_FROM.WEB,
		},
		beneficiaries: [],
		documentTypes: [],
		genders: [],
		states: [],
		townships: [],
		parishes: [],
		phoneCodes: [],
		visibleBeneficiary: false,
	}

	componentDidMount() {
		this.getSelects();
		this.fillForm();
	}

	fillForm = () => {
		const content = this.props?.match?.params?.content;
		const user = content ? JSON.parse(atob(content)) : null;
		if (!user) return;

		this.setState({
			form: {
				name: user?.given_name,
				last_name: user?.family_name,
				gender_id: '',
				dniType: '',
				dni: '',
				phoneCode: '',
				phone: '',
				birthdate: '',
				email: user?.email,
				address: '',
				state_id: '',
				township_id: '',
				parish_id: '',
				password: '',
				password_confirmation: '',
				google: Constants.GOOGLE,
				google_id: user?.sub,
			},
		});
	}

	getSelects = async () => {
		Promise.all([
			GeneralService.getDocumentTypes(),
			GeneralService.getGenders(),
			GeneralService.getPhoneCodes(),
			GeneralService.getStates(),
		])
			.then(res => {
				this.setState({
					documentTypes: res[0] ?? [],
					genders: res[1].map(x => ({ value: x.id, label: x.name })) ?? [],
					phoneCodes: res[2] ?? [],
					states: res[3].map(x => ({ value: x.id, label: x.name })) ?? [],
				});
			})
			.catch(console.log);
	}

	getTownships = async (state_id) => {
		if (!state_id) return;
		GeneralService.getTownships({ state_id })
			.then(res => {
				this.setState({ townships: res.map(x => ({ value: x.id, label: x.name })) });
			})
			.catch(console.log);
	}

	getParishes = async (township_id) => {
		if (!township_id) return;
		GeneralService.getParishes({ township_id })
			.then(res => {
				this.setState({ parishes: res.map(x => ({ value: x.id, label: x.name })) });
			})
			.catch(console.log);
	}

	change = async (value, target) => {
		if (target === 'state_id') {
			this.getTownships(value);
			await this.setState({
				form: { ...this.state.form, township_id: '', parish_id: '' },
			});
		}
		if (target === 'township_id') {
			this.getParishes(value);
			await this.setState({
				form: { ...this.state.form, parish_id: '' },
			});
		}

		this.setState({
			form: { ...this.state.form, [target]: value },
		});
	}

	changeTab = (tab) => {
		this.setState({ tab });
	}

	onGoBack = () => {
		switch (this.state.tab) {
			case TABS.OWNER:
				this.props.history.replace('/');
				return true;

			// case TABS.BENEFICIARIES:
			// 	this.changeTab(TABS.OWNER);
			// 	return true;

			case TABS.VERIFY:
				this.changeTab(TABS.OWNER);
				return true;

			default:
				return null;
		}
	}

	addBeneficiary = (beneficiary) => {
		this.setState(state => ({
			beneficiaries: [...state.beneficiaries, beneficiary],
		}));
	}

	removeBeneficiary = (index) => {
		const others = this.state.beneficiaries.filter((_, i) => i !== index);
		this.setState({ beneficiaries: others });
	}

	submit = async () => {
		const query = new URLSearchParams(this.props.history.location.search);

		try {
			// const beneficiaries = this.state.beneficiaries.map(beneficiary => ({
			// 	...beneficiary,
			// 	birthdate: moment(benefCloseIcon.birthdate).format('YYYY-MM-DD'),
			// }));

			const res = await AuthService.register({
				...this.state.form,
				// referral_code: query.get('referral_code'),
				referral_code: this.props.referral_code,
				birthdate: this.state.form.birthdate ? moment(this.state.form.birthdate).format('YYYY-MM-DD') : '',
				// beneficiaries: JSON.stringify(beneficiaries),
			});

			await this.props.dispatch({ type: 'SET_REFERRAL_CODE', payload: null });
			await this.props.dispatch({ type: 'SET_USER', payload: res.user.user });
			await this.props.dispatch({ type: 'SET_JWT', payload: res.user.token });
			this.props.history.replace('/');
			window.location.reload();

		} catch (error) {
			console.log(error);
		}
	}

	isValidForm = (showError = true) => {
		const onError = (msg) => {
			if (showError) toast.error(msg);
			return false;
		};

		const { form, tab } = this.state;

		if (tab === TABS.OWNER) {
			if (!form.name)
				return onError('El nombre es obligatorio');

			if (!form.last_name)
				return onError('El apellido es obligatorio');

			// if (!form.gender_id)
			// 	return onError('El sexo es obligatorio');

			// if (!form.dniType)
			// 	return onError('El tipo de documento es obligatorio');

			// if (!form.dni)
			// 	return onError('El número de documento es obligatorio');

			if (!form.phoneCode)
				return onError('El código de área es obligatorio');

			if (!form.phone)
				return onError('El teléfono es obligatorio');

			// if (!form.birthdate)
			// 	return onError('La fecha de nacimiento es obligatoria');

			// if (!form.address)
			// 	return onError('La dirección es obligatoria');

			if (!form.email)
				return onError('El correo es obligatorio');

			if (!String(form.email).match(/^[a-z0-9._-]+@[a-z0-9._-]+\.[a-z]{2,3}$/ig))
				return onError('El correo no es válido');

			// if (!form.state_id)
			// 	return onError('El estado es obligatorio');

			// if (!form.township_id)
			// 	return onError('El municipio es obligatorio');

			// if (!form.parish_id)
			// 	return onError('La parroquia es obligatoria');

			if (!form.google && !form.password)
				return onError('La contraseña es obligatoria');

			if (!form.google && form.password !== form.password_confirmation)
				return onError('Las contraseñas no coinciden');
		}

		return true;
	}

	render() {

		const { form, tab } = this.state;
		const isNextStepEnabled = this.isValidForm(false);

		return (
			<div className="w-full sm:max-w-[1440px] mx-auto">
				<button
					className="absolute left-2 top-2 z-10"
					onClick={() => this.onGoBack()}
				>
					<img src={BackIcon} className="w-6 h-6 object-contain brightness-50" alt="" />
				</button>

				<div className="w-full sm:max-w-[800px] mx-auto mt-4">
					<p className="text-center text-darkBlue font-bold text-xl">
						Registro de Usuario
					</p>

					<div className="mx-auto my-8 w-1/2 flex">
						<Tab label="Titular" isActive={TABS.OWNER <= tab} />
						<div className="w-2.5" />
						{/* <Tab label="Beneficiarios" isActive={TABS.BENEFICIARIES <= tab} />
						<div className="w-2.5" /> */}
						<Tab label="Verificar" isActive={TABS.VERIFY <= tab} />
					</div>

					{tab === TABS.OWNER && (
						<div className="flex flex-col sm:grid sm:grid-cols-2 gap-4 px-4 lg:px-0">
							<Input
								placeholder="Nombre"
								value={form.name}
								onChange={v => this.change(v.target.value, 'name')}
							/>

							<Input
								placeholder="Apellido"
								value={form.last_name}
								onChange={v => this.change(v.target.value, 'last_name')}
							/>

							{/*<Select
								placeholder="Sexo"
								items={this.state.genders}
								value={form.gender_id}
								onValueChange={v => this.change(v, 'gender_id')}
							/>

							<div className="flex flex-row items-center">
								<div className="w-1/3">
									<Select
										items={this.state.documentTypes}
										value={form.dniType}
										onValueChange={v => this.change(v, 'dniType')}
									/>
								</div>
								<div className="w-2/3 pl-4">
									<Input
										placeholder="Cédula"
										value={form.dni}
										onChange={v => this.change(sanitizeToNumbers(v.target.value), 'dni')}
										maxLength={9}
									/>
								</div>
							</div>*/}

							<div className="flex flex-row items-center">
								<div className="w-1/3">
									<Select
										items={this.state.phoneCodes}
										value={form.phoneCode}
										onValueChange={v => this.change(v, 'phoneCode')}
									/>
								</div>
								<div className="w-2/3 pl-4">
									<Input
										placeholder="Número de teléfono"
										value={form.phone}
										onChange={v => this.change(sanitizeToNumbers(v.target.value), 'phone')}
										maxLength={7}
									/>
								</div>
							</div>

							{/*<Input
								type="date"
								placeholder="Fecha de nacimiento"
								value={form.birthdate}
								onChange={v => this.change(v.target.value, 'birthdate')}
							/>*/}

							<Input
								placeholder="Correo electrónico"
								value={form.email}
								onChange={v => this.change(v.target.value, 'email')}
								disabled={form.google}
							/>

							{/*<div className="col-span-2 flex items-center gap-x-4 border border-gray3 bg-white rounded-md w-full px-2">
								<textarea
									className="flex-1 outline-none border-none bg-transparent text-sm py-2"
									placeholder="Dirección"
									value={form.address}
									onChange={v => this.change(v.target.value, 'address')}
									rows={3}
								/>
							</div>

							<Select
								placeholder="Estado"
								items={this.state.states}
								value={form.state_id}
								onValueChange={v => this.change(v, 'state_id')}
							/>

							<Select
								placeholder="Municipio"
								items={this.state.townships}
								value={form.township_id}
								onValueChange={v => this.change(v, 'township_id')}
							/>

							<Select
								placeholder="Parroquia"
								items={this.state.parishes}
								value={form.parish_id}
								onValueChange={v => this.change(v, 'parish_id')}
							/>*/}

							{/* <Select
								placeholder="Intermediarios"
								items={[]}
								value=""
								onValueChange={v => {}}
							/> */}

							{!form.google && (
								<>
									<div className="flex items-center mt-4 mb-2.5 col-span-2">
										<img src={LockIcon} className="w-5 h-5 object-contain mr-2.5" alt="" />
										<span className="text-lg text-blue font-bold">Contraseña</span>
									</div>

									<Input
										placeholder="Contraseña"
										secureTextEntry={true}
										value={form.password}
										onChange={v => this.change(v.target.value, 'password')}
									/>

									<Input
										placeholder="Repetir contraseña"
										secureTextEntry={true}
										value={form.password_confirmation}
										onChange={v => this.change(v.target.value, 'password_confirmation')}
									/>
								</>
							)}

							<div className="col-span-2">
								<div className="mx-auto items-center mb-5 w-1/3">
									<button
										className={classNames('mt-8 rounded-lg w-full text-center h-10 bg-blue font-bold text-lg text-white', isNextStepEnabled ? 'bg-blue' : 'bg-gray')}
										onClick={() => {
											if (!this.isValidForm()) return;
											this.changeTab(TABS.VERIFY);
										}}
									>
										<span>Siguiente</span>
									</button>
								</div>
							</div>
						</div>
					)}

					{tab === TABS.VERIFY && (
						<div className="flex-1 px-4 lg:px-0">
							<div className="flex-1 my-5">
								<div className="flex items-center mb-2.5">
									<span className="text-lg text-blue font-bold">Titular</span>
								</div>

								<p>
									<span className="font-semibold">Nombre: </span>
									<span>{form.name} {form.last_name}</span>
								</p>

								{/*<p>
									<span className="font-semibold">Sexo: </span>
									<span>{this.state.genders.find(gender_id => gender_id.value === +form.gender_id)?.label}</span>
								</p>*/}

								{/*<p>
									<span className="font-semibold">C.I.: </span>
									<span>{form.dniType}-{form.dni}</span>
								</p>*/}

								<p>
									<span className="font-semibold">Teléfono: </span>
									<span>{form.phoneCode}{form.phone}</span>
								</p>

								{/*<p>
									<span className="font-semibold">Fecha de nacimiento: </span>
									<span>{moment(form.birthdate).format('DD-MM-YYYY')}</span>
								</p>*/}

								<p>
									<span className="font-semibold">Correo: </span>
									<span>{form.email}</span>
								</p>

								{/*<p>
									<span className="font-semibold">Dirección: </span>
									<span>{form.address}</span>
								</p>

								<p>
									<span className="font-semibold">Estado: </span>
									<span>{this.state.states.find(x => +x.value === +form.state_id)?.label}</span>
								</p>

								<p>
									<span className="font-semibold">Municipio: </span>
									<span>{this.state.townships.find(x => +x.value === +form.township_id)?.label}</span>
								</p>

								<p>
									<span className="font-semibold">Parroquia: </span>
									<span>{this.state.parishes.find(x => +x.value === +form.parish_id)?.label}</span>
								</p>*/}
							</div>

							<div className="mx-auto mb-5 w-1/3">
								<button
									className="mt-8 rounded-lg w-full text-center h-10 bg-blue font-bold text-lg text-white"
									onClick={() => {
										if (this.isValidForm()) this.submit();
									}}
								>
									<span>Guardar</span>
								</button>

								<button
									className="mt-5 rounded-lg w-full text-center h-10 font-bold text-lg text-white"
									onClick={() => this.changeTab(TABS.OWNER)}
								>
									<span>Regresar</span>
								</button>
							</div>
						</div>
					)}
				</div>
			</div>
		);
	}
}

const Input = ({ type, value, onChange, placeholder, maxLength, secureTextEntry, disabled }) => {
	const [isVisible, setIsVisible] = useState(false);
	return (
		<div className="flex items-center gap-x-4 border border-gray3 bg-white rounded-md h-10 w-full px-2">
			<input
				type={secureTextEntry ? (isVisible ? 'text' : 'password') : (type || "text")}
				className="flex-1 outline-none border-none bg-transparent text-sm"
				placeholder={placeholder}
				value={value}
				onChange={onChange}
				maxLength={maxLength}
				disabled={disabled}
			/>
			{secureTextEntry && (
				<button className="focus:outline-none" type="button" onClick={() => setIsVisible(!isVisible)}>
					<img src={isVisible ? PasswordActive : PasswordInactive} className="w-6 h-6" alt="" />
				</button>
			)}
		</div>
	);
}

const Select = ({ defaultValue, items, placeholder, value, onValueChange }) => {
	return (
		<div className="flex items-center gap-x-4 border border-gray3 bg-white rounded-md h-10 w-full text-sm">
			<select
				className="flex-1 outline-none border-none bg-transparent px-2 mr-2"
				placeholder={placeholder ?? 'Seleccione'}
				defaultValue={defaultValue}
				onChange={e => onValueChange(e.target.value)}
				value={value}
			>
				<option value="" disabled>{placeholder ?? 'Seleccione'}</option>
				{items.map((item, index) => (
					<option key={index} value={item.value}>{item.label}</option>
				))}
			</select>
		</div>
	);
}

const Tab = ({ label, isActive }) => (
	<div className="flex-1">
		<p className={classNames('text-center mb-0.5', isActive ? 'text-text' : 'text-gray6')}>
			{label}
		</p>
		<div className={classNames('flex-1 w-full h-1.5 rounded-sm', isActive ? 'bg-green' : 'bg-gray6')} />
	</div>
);

export default connect(state => {
	return {
		referral_code: state.referral_code
	}
})(Register);
